import i18n from '@assets/i18n/config';

export const TradingProcessValue = {
  NoAutomation: 'NO_AUTOMATION',
  PortfolioOptimizer: 'PORTFOLIO_OPTIMIZER',
} as const;

export const TRADING_PROCESS_LIST = [
  {
    value: TradingProcessValue.NoAutomation,
    name: i18n.t('client:tradingProcessItems.NO_AUTOMATION'),
  },
  {
    value: TradingProcessValue.PortfolioOptimizer,
    name: i18n.t('client:tradingProcessItems.PORTFOLIO_OPTIMIZER'),
  },
];
